import { required, email, ValidationRule } from 'vuelidate/lib/validators';

export interface CheckConfig {
  data: {
    email: string | null;
  };
  html: {
    default: {
      header: {
        title: string;
        text: null;
      };
      button: {
        text: string;
        icon: null;
      };
    };
    input: {
      model: string;
      type: string;
      placeholder: string;
      autocomplete?: string;
    }[];
  };
  validations: {
    email: {
      required: () => ValidationRule;
      email: () => ValidationRule;
    };
  };
}

export default {
  data: {
    email: null,
  },
  html: {
    default: {
      header: {
        title: 'Prisijunkite',
        text: null,
      },
      button: {
        text: 'Tęsti',
        icon: null,
      },
    },
    input: [
      {
        model: 'email',
        type: 'email',
        placeholder: 'El. paštas',
        focus: true,
        autocomplete: 'email',
      },
    ],
  },
  validations: {
    email: {
      required,
      email,
    },
  },
};
